namespace GeniuzPOS.CustomReport {
    export interface ReportCustomerSurveyForm {
        SurveyCode: Serenity.StringEditor;
        Question: Serenity.StringEditor;
        ChoiceId: Serenity.IntegerEditor;
        Choice: Serenity.StringEditor;
        Qty: Serenity.IntegerEditor;
    }

    export class ReportCustomerSurveyForm extends Serenity.PrefixedContext {
        static formKey = 'CustomReport.ReportCustomerSurvey';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ReportCustomerSurveyForm.init)  {
                ReportCustomerSurveyForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;

                Q.initFormType(ReportCustomerSurveyForm, [
                    'SurveyCode', w0,
                    'Question', w0,
                    'ChoiceId', w1,
                    'Choice', w0,
                    'Qty', w1
                ]);
            }
        }
    }
}
